import { render, staticRenderFns } from "./OrderDraftItemAvailability.vue?vue&type=template&id=41bcaa3b&"
import script from "./OrderDraftItemAvailability.vue?vue&type=script&lang=js&"
export * from "./OrderDraftItemAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports